import { defineIntegration, consoleSandbox } from '@sentry/core/browser';

const elementTimingIntegrationShim = defineIntegration(() => {
  consoleSandbox(() => {
    console.warn("You are using elementTimingIntegration() even though this bundle does not include element timing.");
  });
  return {
    name: "ElementTiming"
  };
});

export { elementTimingIntegrationShim };
//# sourceMappingURL=ElementTiming.js.map
